// extracted by mini-css-extract-plugin
export default {"getNotificationsButton":"styles_getNotificationsButton__3KW31"};